// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
//import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";
import MKTypography from "components/MKTypography";
//import cource1 from "assets/images/cource1.jpg";
//import cource2 from "assets/images/2tankDive.jpg";
import AnemoneCity from "assets/images/AnemoneCity.jpg";
import LeatherCoral from "assets/images/LeatherCoral.jpg";
import elephantRock from "assets/images/elephantRock.jpg";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import { CardContent, Typography } from "@mui/material";
import WhiteRock from "assets/images/WhiteRock.jpg";
function Wrecksite() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid item xs={12} lg={6}>
          <MKTypography variant="h3" mt={3} mb={0}>
            Reef Dives...
          </MKTypography>
          <MKTypography variant="body1" mt={4} mb={0}>
            Sri Lanka’s East Coast is home to some of the most vibrant reefs in the Indian Ocean.
            From shallow coral gardens teeming with clownfish to deeper sites with turtles and reef
            sharks, these reefs offer unforgettable dives with crystal-clear visibility during the
            May–October season.
          </MKTypography>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Anemone City Reef
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={-8}>
              Located off the East Coast near Trincomalee, Anemone City is one of the most colorful
              and lively reef sites in Sri Lanka. As the name suggests, the reef is blanketed with
              carpets of sea anemones, each hosting playful clownfish darting in and out of their
              swaying homes. This shallow reef, with depths ranging from 5–18 meters, makes it a
              fantastic spot for both beginners and experienced divers. Clear waters during the East
              Coast season (May–October) bring excellent visibility, allowing divers to fully
              appreciate the reef’s vibrant marine life. Expect to see parrotfish, angelfish,
              butterflyfish, and the occasional turtle gliding gracefully by.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 8 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={AnemoneCity}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Anemone City
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Leather Coral
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={-8}>
              Leather corals are a fascinating group of soft corals often found on Sri Lanka’s reef
              sites. Unlike hard corals, they don’t form rigid skeletons but instead have a
              flexible, leathery texture — which is how they got their name. These corals come in a
              variety of shapes, from finger-like projections to broad, mushroom-like colonies,
              creating shelter for small reef fish and invertebrates. They are also known for their
              ability to “shed” their outer layer from time to time, keeping their surface clean and
              healthy.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={LeatherCoral}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  LeatherCoral
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              White Rock
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              White Rock is a popular dive site located off the East Coast of Sri Lanka, near
              Passikudah and Batticaloa. True to its name, the site is marked by a prominent whitish
              rocky formation covered in corals, sponges, and reef life. With depths ranging between
              8–18 meters, it’s perfect for beginner and intermediate divers, offering calm waters
              and great visibility during the East Coast season (May–October). Divers can expect to
              see schools of snapper, fusiliers, angelfish, and an abundance of colorful reef fish
              darting around the rock formations. Turtles and the occasional reef shark may also
              make an appearance, adding excitement to the dive.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={WhiteRock}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  White Rock
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Elephant Rock
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              Elephant Rock is a stunning offshore dive site located near Trincomalee, named after a
              large boulder that rises above the surface resembling the back of an elephant. Beneath
              the waves, the site transforms into a vibrant reefscape with both shallow coral
              gardens and deeper rocky areas, making it suitable for a variety of dive levels. With
              depths ranging from 5–22 meters, divers can encounter schools of reef fish,
              parrotfish, trevallies, and the occasional turtle. During the East Coast season
              (May–October), visibility is excellent, and currents are usually mild, making this
              site perfect for relaxed dives and underwater photography.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={elephantRock}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Elephant Rock
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Wrecksite;
